import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatSort, MatSortModule } from '@angular/material/sort';
import {
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table';
import { EmpresasService } from '../../services/empresa/empresas.service';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormField } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-selecionar-empresa-modal',
  imports: [
    MatIcon,
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatRadioModule,
    MatFormField,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    MatInputModule,
  ],
  templateUrl: './selecionar-empresa-modal.html',
  styleUrl: './selecionar-empresa-modal.scss',
})
export class SelecionarEmpresaModal implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<SelecionarEmpresaModal>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  empresaSelecionadaId: number | null = null;
  displayedColumns: string[] = ['nome', 'cnpj', 'estado', 'cidade'];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatSort) sort!: MatSort;

  filterValue = '';

  async ngOnInit() {
    this.dataSource = new MatTableDataSource(this.data.empresas);
    this.empresaSelecionadaId = this.data.empresaSelecionada?.idEmpresa ?? null;
    this.configurarFiltro();
  }

  ngAfterViewInit() {
    this.configurarSort();
  }

  private configurarFiltro() {
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const normalizedFilter = filter.toLowerCase();
      return (
        data.nomeFantasia.toLowerCase().includes(normalizedFilter) ||
        data.razaoSocial?.toLowerCase().includes(normalizedFilter) ||
        data.cnpj.includes(filter)
      );
    };
  }

  private configurarSort() {
    this.dataSource.sort = this.sort;

    this.dataSource.sortingDataAccessor = (data: any, property: string) => {
      switch (property) {
        case 'nome':
          return data.nomeFantasia.toLowerCase();
        case 'cnpj':
          return data.cnpj;
        case 'estado':
          return data.estado.toLowerCase();
        case 'cidade':
          return data.cidade.toLowerCase();
        default:
          return data[property];
      }
    };
  }

  aplicarFiltro(event: Event) {
    const input = event.target as HTMLInputElement;
    this.filterValue = input.value;
    this.dataSource.filter = this.filterValue.trim();
  }

  fechar() {
    this.dialogRef.close();
  }

  vincularEmpresa() {
    const empresaSelecionada = this.data.empresas.find(
      (e: any) => e.idEmpresa === this.empresaSelecionadaId
    );
    this.dialogRef.close(empresaSelecionada);
  }
}
